import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './Banner.css';

const Banner = () => {
  const navigate = useNavigate();
  const parallaxRef = useRef(null);
  const PARALLAX_RATE = 0.3; 

  const handleClick = () => {
    navigate("/sobre");
  };

  const [backgroundImage, setBackgroundImage] = useState('/images/banner/banner-desktop.webp');

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        setBackgroundImage('/images/banner/banner-mobile.webp');
      } else if (width <= 1024) {
        setBackgroundImage('/images/banner/banner-tablet.webp');
      } else {
        setBackgroundImage('/images/banner/banner-desktop.webp');
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleScroll = useCallback(() => {
    const parallaxElement = parallaxRef.current;

    if (parallaxElement) {
      const scrollPosition = window.scrollY;
      
      parallaxElement.style.transform = `translateY(${scrollPosition * PARALLAX_RATE}px)`; 
    }
  }, [PARALLAX_RATE]); 

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true }); 

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return (
    <div className="parallax-container">
      <div
        className="parallax"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundColor: '#f0f0f0',
        }}
        ref={parallaxRef}
      ></div>
      <div className="banner-text">
        <h2 className='titulo-banner'>Dr. Luciano Gazzoni</h2>
        <p className='p-crm-banner'>CRM 8493-DF | RQE 6960</p>
        <p className='p-banner-1 p-banner'><span className='bold-text'>Renove</span> a sua autoconfiança. </p>
        <p className='p-banner-2 p-banner'><span className='bold-text'>Celebre</span> sua singularidade.</p>
        <div className='banner-btn-container'>
          <button className="banner-btn" onClick={handleClick}>Leia mais</button>
        </div>
      </div>
    </div>
  );
};

export default Banner;